export default __webpack_public_path__ + "static/media/third-trainer.6b009294.jpg";